import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import UserNotification from "../UserNotification";
import UserAvatar from "../UserAvatar";
import ProfileList from "../ProfileList";
import { PROFILE_LISTINGS } from "../../config/Constants";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";

const bellIcon = require("../../assets/images/notif_bell_white.png");

const NotificationAndProfile = ({ setOpenLogoutModal }) => {
  const [avatarClicked, setAvatarClicked] = useState(false);
  const employeeDetails = localStorage.getItem("employeeData");
  const employeeName = JSON.parse(employeeDetails);
  const { extraFields } = useExtraFieldsContext();

  const handleAvatarClick = () => {
    setAvatarClicked(!avatarClicked);
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setAvatarClicked(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  return (
    <NotificationProfileWrapper ref={wrapperRef}>
      <UserNotification src={bellIcon} />
      <AvatarListWrapper>
        {/* userName to be changed after login */}
        <UserAvatar
          imgSrc={extraFields?.photo}
          userName={employeeName?.firstName + " " + employeeName?.lastName}
          onClick={handleAvatarClick}
        />
        {avatarClicked && (
          <ProfileList
            profileListingData={PROFILE_LISTINGS}
            setClose={setAvatarClicked}
            setOpenLogoutModal={setOpenLogoutModal}
            pageEnd
          />
        )}
      </AvatarListWrapper>
    </NotificationProfileWrapper>
  );
};

export default NotificationAndProfile;

const NotificationProfileWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
`;
const AvatarListWrapper = styled.div`
  position: relative;
`;
